var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7296 33.7289C28.1165 33.9883 28.6323 34.118 29.1482 33.8586C29.6641 33.7289 29.922 33.2102 30.051 32.8211C31.2116 27.504 33.9199 14.1462 34.9516 9.34775C35.0806 8.95869 34.9516 8.56963 34.5647 8.31025C34.3068 8.05088 33.9199 7.92119 33.533 8.05088C28.1165 10.1259 11.48 16.3509 4.64483 18.9446C4.25793 19.0743 4 19.4633 4 19.9821C4 20.5008 4.25793 20.8899 4.77379 21.0196C7.86895 21.9274 11.8669 23.2243 11.8669 23.2243C11.8669 23.2243 13.8014 28.9305 14.7041 31.7836C14.8331 32.1727 15.091 32.4321 15.4779 32.5617C15.8648 32.6914 16.2517 32.5618 16.5096 32.3024C18.0572 30.8758 20.5075 28.5414 20.5075 28.5414C20.5075 28.5414 25.1503 31.7836 27.7296 33.7289ZM13.5434 22.4462L15.7358 29.5789L16.2517 25.0399C16.2517 25.0399 24.6344 17.3884 29.4061 13.1087C29.5351 12.979 29.5351 12.7196 29.4061 12.5899C29.2772 12.4602 29.0192 12.4602 28.8903 12.4602C23.3448 16.0915 13.5434 22.4462 13.5434 22.4462Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.599a99a28d2c3e5c8c45580593ab7a38.svg";
export { ForwardRef as ReactComponent };